import { DietarySupplement } from "@app/shared/models/dietary-supplement/dietary-supplement.model";
import { FilterParams } from "@app/shared/models/dietary-supplement/filter-params.model";
import { createAction, props } from "@ngrx/store";

export const loadProducts = createAction(
  "[Dietary supplement / API] Load Products",
);
export const loadProductsSuccess = createAction(
  "[Dietary supplement / API] Load Products Success",
  props<{ products: DietarySupplement[]; meta: any; isAppend: boolean }>(),
);
export const loadProductsFailure = createAction(
  "[Dietary supplement / API] Load Products Failure",
  props<{ error: any }>(),
);

export const loadProductsCachedData = createAction(
  "[Dietary supplement / API cache] Load Products Cached Data: Nothing to load",
);

export const resetCache = createAction(
  "[Dietary supplement / API cache] Reset Cache",
);

export const firstLoadProducts = createAction(
  "[Dietary supplement] First Load Products",
);

export const setProductFilter = createAction(
  "[Dietary supplement / API] Set Product Filter",
  props<{ productFilter: FilterParams }>(),
);

export const loadProductsNextPage = createAction(
  "[Dietary supplement / API] Load Products Next Page",
);

export const updateProduct = createAction(
  "[Dietary supplement] Update Product",
  props<{ product: DietarySupplement }>(),
);

export const checkedProduct = createAction(
  "[Dietary supplement] Checked Product",
  props<{ product: DietarySupplement }>(),
);

export const resetCheckedProducts = createAction(
  "[Dietary supplement] Reset Checked Products",
);

export const addProductsDetailsToStorage = createAction(
  "[Dietary supplement] Add Products Details To Storage",
  props<{ products: Partial<DietarySupplement>[] }>(),
);

export const clearProducts = createAction(
  "[Dietary supplement] Сlear Products",
);

export const toggleProductToLocked = createAction(
  "[Dietary supplement / API] Toggle Product To Locked",
  props<{ product: DietarySupplement }>(),
);

export const toggleProductToLockedSuccess = createAction(
  "[Dietary supplement / API] Toggle Product To Locked Success",
  props<{ product: any }>(),
);
export const toggleProductToLockedFailure = createAction(
  "[Dietary supplement / API] Toggle Product To Locked Failure",
  props<{ error: any }>(),
);

export const removeProductFromCollectRecipe = createAction(
  "[Dietary supplement] Remove Product From Collect Recipe",
  props<{ product: DietarySupplement }>(),
);
